<template>
  <nav
    aria-label="Site Map"
    class="flex flex-col gap-4 text-3xl-bl uppercase lg:flex-row lg:gap-6 lg:text-base lg:font-bold"
  >
    <SiteMapItem v-for="item in parents" :key="item.id" :data="item" />
  </nav>
</template>

<script setup lang="ts">
import type { MenuItemRecord } from '~/types/datocms'

const props = defineProps({
  data: {
    type: Array as PropType<MenuItemRecord[]>,
    default: () => []
  }
})

// Filter top level items
const parents = computed(() => props.data.filter((item) => item.parent === null))
</script>
